/**
 * Collection list (product list layout): AJAX Add to cart + variant selector sync.
 * Uses event delegation so one listener handles all cards.
 */
(function () {
  if (typeof fetchConfig === 'undefined' || typeof routes === 'undefined') return;

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // ----- Variant select: sync chosen variant to both forms in the same card -----
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('variant-select')) return;
    const content = e.target.closest('.collection-list__content');
    if (!content) return;
    const variantId = e.target.value;
    content.querySelectorAll('form input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
  });

  // ----- Add to cart form: submit via AJAX and update cart drawer -----
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.classList.contains('collection-list-add-to-cart-form')) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
      const spinner = submitBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.credentials = 'same-origin';

    const formData = new FormData(form);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'collection-list',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          if (submitBtn) {
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          }
          return;
        }

        if (!cart) {
          window.location = routes.cart_url;
          return;
        }

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          var startMarker = typeof CartPerformance !== 'undefined'
            ? CartPerformance.createStartingMarker('add:wait-for-subscribers')
            : null;
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'collection-list',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(function () {
            if (startMarker && typeof CartPerformance !== 'undefined') {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            }
          });
        }

        if (typeof CartPerformance !== 'undefined') {
          CartPerformance.measure('add:paint-updated-sections', function () {
            cart.renderContents(response);
          });
        } else {
          cart.renderContents(response);
        }
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err);
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
      });
  });
})();
